import { AccountProviderType } from 'owa-accounts-store';
import { AccountsEditorSource } from './AccountsEditorSource';

export default interface AccountsEditorStore {
    /**
     * The account which is pending a true time status update
     */
    accountPendingTrueTimeUpdate: string;

    /**
     * The account which failed to update true time status
     */
    trueTimeUpdateFailedAccount: string;

    /**
     * accounts state with respect to editor
     */
    accountsEditorState: AccountsEditorState;

    /**
     * The selected account provider type
     */
    selectedAccountProvider: AccountProviderType;

    /**
     * The source hosting this component used for logging
     */
    source: AccountsEditorSource;
}

export enum AccountsEditorState {
    None = 0,
    Adding = 1,
    Added = 2,
    AddFailed = 3,
    Removing = 4,
    Removed = 5,
    RemoveFailed = 6,
    ReconnectFailed = 7,
}
